export const APP_TRANSIENT_HISTORY_MARKER_KEY = '__mtAscupTransientSurface';

export function hasAppTransientHistoryMarker(state: unknown): boolean {
  return (
    state !== null &&
    typeof state === 'object' &&
    !Array.isArray(state) &&
    typeof (state as Record<string, unknown>)[
      APP_TRANSIENT_HISTORY_MARKER_KEY
    ] === 'string'
  );
}
